import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const GetContentPostsSlice = createSlice({
    name: "getContentPosts",
    initialState,
    reducers: {
        getContentPostsRequest(state) {
            state.loading = true;
        },
        getContentPostsRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        getContentPostsRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
    },
});

export const {
    getContentPostsRequest,
    getContentPostsRequestSuccess,
    getContentPostsRequestError,
} = GetContentPostsSlice.actions;

export default GetContentPostsSlice.reducer;
